import { useMutation } from '@tanstack/react-query';
import { type RemoveTagMembersRequest, tagsApi } from 'API/tags-api';
import { tagsQueryKeys } from 'hooks/queries/tags/tag-keys';

export const useRemoveTagMembersMutation = () => {
    return useMutation({
        mutationKey: tagsQueryKeys.removeTagMembers,
        mutationFn: async (props: RemoveTagMembersRequest) => {
            return tagsApi.removeTagMembers(props);
        },
    });
};
